import firebase from "@/plugins/firebase";
import loading from "@/utils/loading";
import store from "@/store";

export default class Service {
  constructor() {
    this._auth = firebase.auth();
    this._db = firebase.firestore();
    this._storage = firebase.storage();
    this._functions = firebase.functions();
    this._loading = loading;

    this._store = store;

    /**
     * Example: `${this._prefix}-gruposEmpresa/${this._grupoPrincipal}/collection/...`
     */
    this._prefix = store.getters["auth/getPrefix"]; //prefixo do usuario
    this._grupoPrincipal = store.getters["auth/getGrupoPrincipal"]; //grupo principal do usuario
    this._empresaPrincipal = store.getters["auth/getEmpresaPrincipal"]; //empresa principal do usuario
  }
}
